// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_he","advertCardNum":"c-a_hf"};